import { useNode } from "@craftjs/core";
import React from "react";
import { isUpdatedFromDefault } from "../../utils";

import {
  ListClipboardIcon,
  ListOrderedActiveIcon,
  ListOrderedIcon,
  ListUnorderedActiveIcon,
  ListUnorderedIcon,
  PencilActiveIcon,
  PaintIcon,
  SettingsIcon,
  ListAlphabetical,
} from "../../../assets/ui-icons";

import {
  ColorInput,
  OptionsInput,
  MarginInput,
  PaddingInput,
  Panel,
  SpacerInput,
  Tabs,
  FormatOptionsInput,
} from "./../../ui-kit";
import RightBar from "../../ui-kit/rightbar";
import { IconPack } from "../../../assets/icon-pack";

export const CMSListSettings = () => {
  const {
    actions: { setProp },
    props,
    id,
  } = useNode((node) => ({
    text: node.data.props.text,
    props: node.data.props,
  }));

  const {
    textColor,
    backgroundColor,
    linkColor,
    layoutPadding,
    layoutMargin,
    listType = "ul",
  } = props;

  const General = () => {
    return (
      <>
        <SpacerInput>
          <OptionsInput
            label={"Type"}
            value={listType}
            onChange={(val) => {
              setProp((props) => {
                props.listType = val;
              });
            }}
            isResetVisible={false}
            options={[
              {
                label: "Bullets",
                value: "ul",
                icon: (
                  <ListUnorderedIcon className="text-black" width={"20px"} />
                ),
                active: (
                  <ListUnorderedActiveIcon
                    className="text-white"
                    width={"20px"}
                  />
                ),
              },
              {
                label: "Numbered",
                value: "ol",
                icon: <ListOrderedIcon className="text-black" width={"20px"} />,
                active: (
                  <ListOrderedIcon className="text-white" width={"20px"} />
                ),
              },
              {
                label: "A-Z",
                value: "sort",
                icon: (
                  <ListAlphabetical className="text-black" width={"20px"} />
                ),
                active: (
                  <ListAlphabetical className="text-white" width={"20px"} />
                ),
              },
            ]}
          />
          <FormatOptionsInput label={"Font Style"} />
        </SpacerInput>
      </>
    );
  };

  const Styles = () => {
    return (
      <div className="w-full rounded-[21px] py-2 bg-white flex flex-col">
        <Panel label={"Colors"} isOpen={true}>
          <SpacerInput>
            <ColorInput
              value={textColor}
              onChange={(val) => {
                setProp((props) => {
                  props.textColor = val;
                });
              }}
              label={"Text"}
              useTextColorPalette={true}
              supportSelection={true}
            />
            <ColorInput
              value={backgroundColor}
              onChange={(val) => {
                setProp((props) => {
                  props.backgroundColor = val;
                });
              }}
              label={"Background"}
            />
            <ColorInput
              value={linkColor}
              onChange={(val) => {
                setProp((props) => {
                  props.linkColor = val;
                });
              }}
              label={"Link"}
              useTextColorPalette={true}
              supportSelection={true}
            />
          </SpacerInput>
        </Panel>
      </div>
    );
  };

  const Advance = () => {
    return (
      <SpacerInput>
        <PaddingInput
          value={layoutPadding}
          onChange={(val) => {
            setProp((props) => {
              props.layoutPadding = val;
            });
          }}
        />
        <MarginInput
          value={layoutMargin}
          onChange={(val) => {
            setProp((props) => {
              props.layoutMargin = val;
            });
          }}
        />
      </SpacerInput>
    );
  };

  const tabs = [
    {
      label: "General",
      key: "general",
      icon: IconPack.GeneralSettings,
      children: General(),
      isUpdated: isUpdatedFromDefault([]),
    },
    {
      label: "Style",
      key: "style",
      icon: IconPack.Style,
      children: Styles(),
      isUpdated: isUpdatedFromDefault([]),
    },
    {
      label: "Advanced",
      key: "advanced",
      icon: IconPack.Settings,
      children: Advance(),
      isUpdated: isUpdatedFromDefault([]),
    },
  ];

  return (
    <div className="h-full w-[330px] post-edit-right-sidebar p-2 cursor-default overflow-auto dashboard-ui-scrollbar ">
      <div className="w-full rounded-t-[21px] bg-white">
        <div className="p-5 flex justify-between">
          <RightBar
            title={"List"}
            icon={<ListClipboardIcon className="h-[36px] w-[36px]" />}
          />
        </div>

        <Tabs id={`block-cms-settings-tab-${id}`} items={tabs} />

        <div className="py-2 bg-ui-light-white"></div>
      </div>
    </div>
  );
};
